import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const languages = ['et', 'en', 'ru'];

const namespaces = [
  'common',
  'signInPage',
  'header',
  'contractsTable',
  'table',
  'userSettings',
  'dashboardPage',
  'containersPage',
  'communicationPage',
  'invoicesPage',
  'desktopPage',
  'serviceHistoryPage',
  'table',
  'objectsTable',
  'objectItemsTable',
  'session',
  'contractsPage',
  'inAdsWidget',
  'contractModal',
  'contractAttorneyModal',
  'orderAdditionalDischargeModal',
  'footer',
  'wasteCalendar',
];

const loadTranslations = (lang: string) => {
  fetch(`/locales/${lang}.json`)
    .then((response) => response.json())
    .then((data) => {
      namespaces.forEach((namespace) => {
        i18n.addResourceBundle(lang, namespace, data[namespace], true, false);
      });
    })
    .catch((error) => {
      console.error(`Failed to load translations for ${lang}`, error);
    });
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'et',
    returnNull: false,
    ns: namespaces,
    defaultNS: 'common',
    fallbackNS: 'common',
    fallbackLng: 'et',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
  });

languages.forEach((lang) => {
  loadTranslations(lang);
});

export default i18n;
